var exports = {
  "k": "x43aef4ae--bb9e82--container",
};

module.exports = exports;
